import { Type, Index } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';

const MapValueError = (error) => ({
    message: error.message,
    path: error.path,
    errors: error.errors.map(iterator => mapValueErrorIterator(iterator))
});
const mapValueErrorIterator = (iterator) => [...iterator].map(error => MapValueError(error));

class DataLayerError extends Error {
    constructor({ message, errors = [] }) {
        super(message);
        this.message = message;
        this.validationErrors = mapValueErrorIterator(errors);
    }
}

/**
 * ATTENTION. This code was AUTO GENERATED by schema2typebox.
 * While I don't know your use case, there is a high chance that direct changes
 * to this file get lost. Consider making changes to the underlying JSON schema
 * you use to generate this file instead. The default file is called
 * "schema.json", perhaps have a look there! :]
 */
const types = Type.Object({
    pageData: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "pageData", readOnly: true })),
        href: Type.String({}),
        pagePath: Type.String({}),
        pageTitle: Type.String({}),
        pageName: Type.Optional(Type.String({})),
        pageType: Type.Optional(Type.String({})),
        siteContentHierarchy: Type.Optional(Type.String({})),
        viewportDimensions: Type.Optional(Type.Union([
            Type.String({
                pattern: "^\\d*\\:\\d*$",
                examples: ["1920:1080"],
            }),
            Type.Null({
                pattern: "^\\d*\\:\\d*$",
                examples: ["1920:1080"],
            }),
        ])),
        pageLoadSpeedFirstByte: Type.Optional(Type.Number({})),
        pageLoadSpeedDomReady: Type.Optional(Type.Number({})),
        localTimestamp: Type.String({
            pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
            examples: ["2000-01-00T00:00:00.839Z"],
        }),
        hostname: Type.String({}),
        queryString: Type.String({}),
        browseCurrency: Type.String({}),
        browseCountry: Type.String({}),
        language: Type.Optional(Type.String({})),
        channel: Type.Union([
            Type.Literal("women"),
            Type.Literal("men"),
            Type.Literal("default"),
            Type.Literal("checkout"),
        ], {
            $schema: "http://json-schema.org/draft-07/schema#",
        }),
        deviceType: Type.Union([
            Type.Literal("desktop"),
            Type.Literal("mobile"),
            Type.Literal("tablet"),
        ], {}),
        env: Type.Union([Type.Literal("test"), Type.Literal("prod")], {}),
        referringUrl: Type.String({}),
        marketingData: Type.Optional(Type.Object({
            affid: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            nlid: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            googleCid: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            gclid: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            ranSiteId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            ranLandingDate: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            ranMid: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            awinId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            admitadId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            fbAdId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            fbLandingDate: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            impactRadiusClickId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            asosConnectTransactionId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            buttonId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            crealyticsId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            intelligentReachId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            publisherReference: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            zanoxPartnerId: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
        }, {})),
        customerData: Type.Optional(Type.Object({
            isAuthenticated: Type.Optional(Type.Boolean({})),
            customerId: Type.Optional(Type.String({})),
            firstTimeBuyer: Type.Optional(Type.Boolean({})),
            premierStatus: Type.Optional(Type.Boolean({})),
            studentStatus: Type.Optional(Type.Boolean({})),
            hashedEmail: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            normalisedHashedEmail: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            firstName: Type.Optional(Type.String({})),
            hashedFirstName: Type.Optional(Type.String({})),
            hashedLastName: Type.Optional(Type.String({})),
            hashedPhoneNumber: Type.Optional(Type.Union([
                Type.String({}),
                Type.Null({}),
            ])),
            geoIpCountryCode: Type.Optional(Type.String({})),
            asosWorldTier: Type.Optional(Type.String({})),
            customerSegments: Type.Optional(Type.Array(Type.String(), {})),
        }, {})),
        webVersion: Type.Optional(Type.String({})),
        ctaRef: Type.Optional(Type.String({})),
        pageComponents: Type.Optional(Type.Array(Type.String({}), {})),
        attributionCategory: Type.Optional(Type.String({})),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/pageData.json",
        additionalProperties: false,
    })),
    customerPremierData: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "customerPremierData", readOnly: true })),
        premierStatus: Type.String({}),
        freeTrialAvailable: Type.Boolean({}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/customerPremierData.json",
        additionalProperties: false,
    })),
    customerSegmentsData: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "customerSegmentsData", readOnly: true })),
        segments: Type.Array(Type.String({}), {}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/customerSegmentsData.json",
        additionalProperties: false,
    })),
    customerLoyaltyData: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "customerLoyaltyData", readOnly: true })),
        consentStatus: Type.Union([
            Type.String({
                examples: ["OptedIn", "OptedOut"],
            }),
            Type.Null({
                examples: ["OptedIn", "OptedOut"],
            }),
        ]),
        currentTierId: Type.Union([
            Type.String({
                examples: ["GB_LOYT_1", "GB_LOYT_2", "US_LOYT_1"],
            }),
            Type.Null({
                examples: ["GB_LOYT_1", "GB_LOYT_2", "US_LOYT_1"],
            }),
        ]),
        tierNumber: Type.Union([
            Type.Number({}),
            Type.Null({}),
        ]),
        country: Type.Union([
            Type.String({}),
            Type.Null({}),
        ]),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/customerLoyaltyData.json",
        additionalProperties: false,
    })),
    customerStudentData: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "customerStudentData", readOnly: true })),
        isStudent: Type.Boolean({}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/customerStudentData.json",
        additionalProperties: false,
    })),
    OneTrustGroupsUpdated: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "OneTrustGroupsUpdated", readOnly: true })),
        OnetrustActiveGroups: Type.String({
            examples: ["C0001", "C0001,C0002,C0003"],
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/OneTrustGroupsUpdated.json",
        additionalProperties: false,
    })),
    timeToFirstByteData: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "timeToFirstByte", readOnly: true })),
        value: Type.Number({}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/timeToFirstByteEvent.json",
        additionalProperties: false,
    })),
    firstContentfulPaintData: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "firstContentfulPaint", readOnly: true })),
        value: Type.Number({}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/firstContentfulPaintEvent.json",
        additionalProperties: false,
    })),
    add_shipping_info: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "add_shipping_info", readOnly: true })),
        ecommerce: Type.Optional(Type.Object({
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            shipping_tier: Type.Optional(Type.String({})),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        })),
        section: Type.Optional(Type.String({ default: "deliveryOptions", readOnly: true })),
        deliveryOptionId: Type.Optional(Type.Number({})),
        isSplitFulfilment: Type.Optional(Type.Boolean({})),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/add_shipping_info.json",
    })),
    begin_checkout: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "begin_checkout", readOnly: true })),
        ecommerce: Type.Object({
            checkout_id: Type.Optional(Type.Union([
                Type.Union([
                    Type.String({}),
                    Type.Null({}),
                ]),
            ], { $schema: "http://json-schema.org/draft-07/schema#" })),
            cart_id: Type.Optional(Type.Union([
                Type.Union([
                    Type.String({}),
                    Type.Null({}),
                ]),
            ], { $schema: "http://json-schema.org/draft-07/schema#" })),
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/begin_checkout.json",
        additionalProperties: false,
    })),
    add_to_cart: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "add_to_cart", readOnly: true })),
        component_name: Type.Optional(Type.Union([
            Type.Literal("pdp_hero"),
            Type.Literal("pdp_btl"),
            Type.Literal("saved_list"),
        ], {
            $schema: "http://json-schema.org/draft-07/schema#",
        })),
        ecommerce: Type.Optional(Type.Object({
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        })),
        request_id: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
        })),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/add_to_cart.json",
    })),
    cart_updated: Type.Optional(Type.Object({
        event: Type.String({ default: "cart_updated", readOnly: true }),
        totalItemCount: Type.Optional(Type.Number({})),
        ecommerce: Type.Object({
            cart_id: Type.Optional(Type.Union([
                Type.Union([
                    Type.String({}),
                    Type.Null({}),
                ]),
            ], { $schema: "http://json-schema.org/draft-07/schema#" })),
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
            source: Type.Optional(Type.String({})),
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/cart_updated.json",
        additionalProperties: false,
    })),
    view_item: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "view_item", readOnly: true })),
        productId: Type.Number({}),
        productCode: Type.String({}),
        availableSku: Type.Optional(Type.Number({})),
        availableSizes: Type.Optional(Type.Number({})),
        productUrl: Type.String({}),
        cid: Type.Union([
            Type.Number({}),
            Type.Null({}),
        ]),
        category: Type.Optional(Type.String({})),
        variantStockStatus: Type.Optional(Type.Array(Type.Object({
            variantId: Type.Number({}),
            variantSku: Type.String({}),
            stockStatus: Type.String({}),
        }, {
            additionalProperties: false,
        }), {})),
        ecommerce: Type.Object({
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        }),
        request_id: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
        })),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/ViewItem.json",
        additionalProperties: false,
    })),
    view_item_list: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "view_item_list", readOnly: true })),
        item_list_name: Type.Union([
            Type.Literal("search"),
            Type.Literal("brand"),
            Type.Literal("category"),
            Type.Literal("wishlist"),
            Type.Literal("plp_carousel"),
            Type.Literal("pdp_ymal"),
            Type.Literal("pdp_pab"),
            Type.Literal("bag_pab"),
            Type.Literal("pdp_btl"),
            Type.Literal("brand_directory"),
        ], {}),
        item_list_state: Type.Optional(Type.Union([
            Type.Literal("search"),
            Type.Literal("failed_search"),
            Type.Literal("category"),
            Type.Literal("generic_search"),
            Type.Literal("pagination"),
            Type.Literal("refinement"),
            Type.Literal("sort"),
            Type.Literal("sort_and_refinement"),
        ], {})),
        search_term: Type.Optional(Type.String({})),
        searchType: Type.Optional(Type.String({})),
        categoryID: Type.Optional(Type.Number({})),
        pageGridSize: Type.Optional(Type.Number({})),
        pageNumber: Type.Optional(Type.Number({})),
        pageSize: Type.Optional(Type.Number({})),
        totalStyles: Type.Optional(Type.Number({})),
        floor: Type.Optional(Type.Union([
            Type.Literal("men"),
            Type.Literal("women"),
            Type.Literal("search"),
            Type.Literal("default"),
        ], { description: "The customer’s floor." })),
        breadCrumb: Type.Optional(Type.String({
            pattern: ".*[A-Za-zÀ-ÖØ-öø-ÿ0-9 &']+%\\$[A-Za-zÀ-ÖØ-öø-ÿ0-9 &']+(%\\$[A-Za-zÀ-ÖØ-öø-ÿ0-9 &']+)*.*",
        })),
        refinements: Type.Optional(Type.Object({
            context: Type.Optional(Type.String({})),
            listAppliedRefinements: Type.Optional(Type.Array(Type.Object({
                refinementId: Type.Optional(Type.String({ description: "Facet ID" })),
                refinementName: Type.Optional(Type.String({ description: "Facet name" })),
                selections: Type.Optional(Type.Array(Type.Object({
                    selectionId: Type.Optional(Type.String({ description: "Selection ID" })),
                    selectionName: Type.Optional(Type.String({ description: "Selection name" })),
                }), {})),
            }), { description: "The list of applied refinements" })),
            sort: Type.Optional(Type.Object({
                sortName: Type.Optional(Type.String({ description: "Sort name" })),
                sortType: Type.Optional(Type.String({ description: "Sort option" })),
            }, { description: "The sorting applied." })),
        }, { description: "The refinements applied by the customer" })),
        ecommerce: Type.Object({
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        }),
        request_id: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
        })),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/ViewItemListData.json",
        additionalProperties: false,
    })),
    view_cart: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "view_cart", readOnly: true })),
        totalItemCount: Type.Number({}),
        ecommerce: Type.Object({
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/view_cart.json",
        additionalProperties: false,
    })),
    add_payment_info: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "add_payment_info", readOnly: true })),
        ecommerce: Type.Optional(Type.Object({
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            payment_type: Type.Optional(Type.String({})),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        })),
        section: Type.Optional(Type.String({ default: "paymentOptions", readOnly: true })),
        isSavedPayment: Type.Optional(Type.Boolean({})),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/add_payment_info.json",
    })),
    customerIdentityData: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "customerIdentityData", readOnly: true })),
        customerId: Type.Optional(Type.String({})),
        lastAction: Type.Optional(Type.Union([
            Type.Literal("none"),
            Type.Literal("signUpSocial"),
            Type.Literal("signUpEmail"),
            Type.Literal("linkAccounts"),
            Type.Literal("savedBillingAddress"),
            Type.Literal("savedBillingAndDeliveryAddress"),
            Type.Literal("signInSocial"),
            Type.Literal("signInEmail"),
        ], {})),
        firstTimeBuyer: Type.Optional(Type.Boolean({})),
        geoIpCountryCode: Type.Optional(Type.String({})),
        hashedFirstName: Type.Optional(Type.String({})),
        hashedLastName: Type.Optional(Type.String({})),
        hashedEmail: Type.Optional(Type.String({})),
        hashedPhoneNumber: Type.Optional(Type.String({})),
        isAuthenticated: Type.Boolean({}),
        customerSubscriptionCountry: Type.Optional(Type.String({})),
        loyaltyTier: Type.Optional(Type.String({})),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/customerIdentityData.json",
        additionalProperties: false,
    })),
    add_to_wishlist: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "add_to_wishlist", readOnly: true })),
        component_name: Type.Optional(Type.Union([
            Type.Literal("pdp_hero"),
            Type.Literal("pdp_btl"),
            Type.Literal("saved_list"),
        ], {
            $schema: "http://json-schema.org/draft-07/schema#",
        })),
        ecommerce: Type.Object({
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/add_to_wishlist.json",
        additionalProperties: false,
    })),
    purchase: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "purchase", readOnly: true })),
        page: Type.Optional(Type.String({ default: "orderConfirmed", readOnly: true })),
        context: Type.Optional(Type.Object({
            dateTimePair: Type.Optional(Type.String({
                pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
            })),
        }, {})),
        order: Type.Object({
            orderReference: Type.Optional(Type.String({})),
            currency: Type.Optional(Type.String({})),
            sizeSchema: Type.Optional(Type.String({})),
            totalSalesTax: Type.Optional(Type.Number({
                minimum: 0,
            })),
            totalSalesTaxGbp: Type.Optional(Type.Number({
                minimum: 0,
            })),
            totalPrice: Type.Optional(Type.Number({
                minimum: 0,
            })),
            totalPriceGbp: Type.Optional(Type.Number({
                minimum: 0,
            })),
            discountCode: Type.Optional(Type.Object({
                code: Type.Optional(Type.String({})),
                totalAmount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                totalAmountGbp: Type.Optional(Type.Number({
                    minimum: 0,
                })),
            }, {})),
            delivery: Type.Optional(Type.Object({
                deliveryCountryIsoCode: Type.Optional(Type.String({ description: "3166-1 alpha-2 code." })),
                deliveryOptionId: Type.Optional(Type.Number({})),
                isSplitFulfilment: Type.Optional(Type.Boolean({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceGbp: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                salesTax: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                salesTaxGbp: Type.Optional(Type.Number({
                    minimum: 0,
                })),
            }, { description: "Delivery Information Object." })),
            payment: Type.Optional(Type.Object({
                billingCity: Type.Optional(Type.String({})),
                billingCountryIsoCode: Type.Optional(Type.String({})),
                billingPostCode: Type.Optional(Type.String({})),
                billingState: Type.Optional(Type.String({ description: "State or County." })),
                paymentMethods: Type.Optional(Type.Array(Type.Object({
                    paymentMethod: Type.String({}),
                    cardScheme: Type.Optional(Type.String({})),
                    voucherType: Type.Optional(Type.Union([
                        Type.Literal("Loyalty"),
                        Type.Literal("Gift card"),
                        Type.Literal("Standard"),
                        Type.Literal("Out of policy return"),
                    ], {})),
                    amount: Type.Optional(Type.Number({})),
                    amountRedeemable: Type.Optional(Type.Number({})),
                }, {
                    $schema: "http://json-schema.org/draft-07/schema#",
                    additionalProperties: false,
                }), {})),
            }, { description: "Payment information object" })),
        }, {}),
        ecommerce: Type.Object({
            cart_id: Type.Optional(Type.Union([
                Type.Union([
                    Type.String({}),
                    Type.Null({}),
                ]),
            ], { $schema: "http://json-schema.org/draft-07/schema#" })),
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            payment_type: Type.Optional(Type.String({})),
            transaction_id: Type.Optional(Type.String({})),
            coupon: Type.Optional(Type.String({})),
            discount: Type.Optional(Type.Number({})),
            discountLocalCurrency: Type.Optional(Type.Number({})),
            shipping: Type.Optional(Type.Number({})),
            shippingLocalCurrency: Type.Optional(Type.Number({})),
            tax: Type.Optional(Type.Number({ description: "Tax cost in GBP (if applicable)." })),
            taxLocalCurrency: Type.Optional(Type.Number({})),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/purchase.json",
        additionalProperties: false,
    })),
    available_components: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "available_components", readOnly: true })),
        components: Type.Array(Type.Object({
            position: Type.Number({}),
            component_name: Type.String({}),
        }), {}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/available_components.json",
        additionalProperties: false,
    })),
    customVariables: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "customVariables", readOnly: true })),
        customVariables: Type.Object({
            "1": Type.Object({
                name: Type.String({
                    default: "countryCode",
                }),
                value: Type.String({
                    examples: ["GB", "US"],
                }),
            }, { description: "The country code of the customer" }),
            "3": Type.Object({
                name: Type.String({
                    default: "asosDeviceType",
                }),
                value: Type.String({
                    examples: ["desktop", "mobile", "tablet"],
                }),
            }, { description: "The device type used by the customer" }),
            "4": Type.Object({
                name: Type.String({
                    default: "storeCode",
                }),
                value: Type.String({
                    examples: ["COM"],
                }),
            }, { description: "The store code identifier" }),
            "9": Type.Object({
                name: Type.String({
                    default: "pageType",
                }),
                value: Type.String({}),
            }, { description: "The type of page being viewed" }),
        }, {
            additionalProperties: false,
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/content_square_custom_variables.json",
        additionalProperties: false,
    })),
    experiment_activation: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "experiment_activation", readOnly: true })),
        experiments: Type.Array(Type.Object({
            key: Type.String({
                examples: ["emf123"],
            }),
            variation: Type.String({
                examples: ["on", "off"],
            }),
        }), {}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/experiment_activation.json",
        additionalProperties: false,
    })),
    failed_event: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "failed_event", readOnly: true })),
        errors: Type.Optional(Type.Array(Type.Unknown(), {})),
        event_context: Type.Optional(Type.Unknown()),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/failed_event.json",
    })),
    cta_response: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "cta_response", readOnly: true })),
        cta_response_type: Type.Union([Type.Literal("error"), Type.Literal("success")], {}),
        cta_response_name: Type.String({
            minLength: 1,
        }),
        cta_reference: Type.String({
            minLength: 1,
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/cta_response.json",
        additionalProperties: false,
    })),
    cta_click: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "cta_click", readOnly: true })),
        cta_reference: Type.String({
            minLength: 1,
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/cta_click.json",
        additionalProperties: false,
    })),
    notify_me_button_click: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "notify_me_button_click", readOnly: true })),
        component_name: Type.Optional(Type.Union([
            Type.Literal("pdp_hero"),
            Type.Literal("pdp_btl"),
            Type.Literal("saved_list"),
        ], {
            $schema: "http://json-schema.org/draft-07/schema#",
        })),
        ecommerce: Type.Object({
            currency: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
                default: "GBP",
                readOnly: true,
            })),
            localCurrencyCode: Type.Optional(Type.String({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            value: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            valueLocalCurrency: Type.Optional(Type.Number({
                $schema: "http://json-schema.org/draft-07/schema#",
            })),
            items: Type.Optional(Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }))),
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/notify_me_button_click.json",
        additionalProperties: false,
    })),
    successful_login: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "successful_login", readOnly: true })),
        authentication_channel: Type.Union([
            Type.Literal("unknown"),
            Type.Literal("social"),
            Type.Literal("email"),
        ], {
            $schema: "http://json-schema.org/draft-07/schema#",
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/successful_login.json",
        additionalProperties: false,
    })),
    successful_registration: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "successful_registration", readOnly: true })),
        authentication_channel: Type.Union([
            Type.Literal("unknown"),
            Type.Literal("social"),
            Type.Literal("email"),
        ], {
            $schema: "http://json-schema.org/draft-07/schema#",
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/successful_registration.json",
        additionalProperties: false,
    })),
    view_article_list: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "view_article_list", readOnly: true })),
        article_list_name: Type.String({
            examples: ["Product & Stock", "search"],
        }),
        article_list_state: Type.Union([
            Type.Literal("search"),
            Type.Literal("failed_search"),
            Type.Literal("topic"),
            Type.Literal("pagination"),
        ], {}),
        search_term: Type.Optional(Type.String({
            examples: ["red dress", "shoes size 8", "winter coat"],
        })),
        pageNumber: Type.Optional(Type.Number({
            minimum: 0,
        })),
        pageSize: Type.Optional(Type.Number({
            minimum: 0,
        })),
        totalArticles: Type.Optional(Type.Number({
            minimum: 0,
        })),
        articles: Type.Array(Type.Object({
            article_name: Type.Optional(Type.String({})),
        }, { additionalProperties: false }), {}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/view_article_list.json",
        additionalProperties: false,
    })),
    variant_selected: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "variant_selected", readOnly: true })),
        variantId: Type.String({}),
        component_name: Type.Union([
            Type.Literal("pdp_hero"),
            Type.Literal("pdp_btl"),
            Type.Literal("saved_list"),
        ], {
            $schema: "http://json-schema.org/draft-07/schema#",
        }),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/variant_selected.json",
        additionalProperties: false,
    })),
    view_order_details: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "view_order_details", readOnly: true })),
        orderId: Type.Number({}),
        orderReference: Type.String({}),
        orderStatus: Type.String({}),
        createdDate: Type.String({
            examples: ["2025-08-02T12:49:31.9122811Z"],
            pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
        }),
        store: Type.String({}),
        shop: Type.Union([Type.Literal("asos"), Type.Literal("topshop")], {
            $schema: "http://json-schema.org/draft-07/schema#",
        }),
        lang: Type.String({}),
        estimatedRemorseExpiryDate: Type.Union([
            Type.String({
                pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
            }),
            Type.Null(),
        ], {}),
        cancellationDate: Type.Union([
            Type.String({
                pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
            }),
            Type.Null(),
        ], {}),
        isReturnable: Type.Boolean({}),
        isWithinReturnWindow: Type.Boolean({}),
        returnWindowEndDate: Type.Union([
            Type.String({
                pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
            }),
            Type.Null(),
        ], { description: "The date when the return window ends" }),
        isCancellable: Type.Boolean({}),
        orderDispatchedDate: Type.Union([
            Type.String({
                pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
            }),
            Type.Null(),
        ], { description: "The date when the order was dispatched" }),
        orderDeliveredDate: Type.Union([
            Type.String({
                pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
            }),
            Type.Null(),
        ], { description: "The date when the order was delivered" }),
        parentOrderReference: Type.Union([
            Type.String({}),
            Type.Null({}),
        ]),
        rootOrderReference: Type.Union([
            Type.String({}),
            Type.Null({}),
        ]),
        notReturnableReasonCode: Type.Union([
            Type.String({}),
            Type.Null({}),
        ]),
        createReturnByDate: Type.Union([
            Type.String({
                pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
            }),
            Type.Null(),
        ], { description: "The date by which a return must be created" }),
        items: Type.Array(Type.Object({
            item_id: Type.Optional(Type.String({})),
            productId: Type.Optional(Type.String({})),
            productCode: Type.Optional(Type.String({})),
            variantId: Type.Optional(Type.String({})),
            item_name: Type.Optional(Type.String({})),
            discount: Type.Optional(Type.Number({
                minimum: 0,
            })),
            discountLocalCurrency: Type.Optional(Type.Number({
                minimum: 0,
            })),
            index: Type.Optional(Type.Number({})),
            item_brand: Type.Optional(Type.String({})),
            item_category: Type.Optional(Type.String({})),
            item_variant: Type.Optional(Type.String({})),
            price: Type.Optional(Type.Number({
                minimum: 0,
            })),
            priceLocalCurrency: Type.Optional(Type.Number({
                minimum: 0,
            })),
            quantity: Type.Optional(Type.Number({
                minimum: 0,
            })),
            coupon: Type.Optional(Type.String({})),
            size: Type.Optional(Type.String({})),
            image_url: Type.Optional(Type.String({})),
            itemType: Type.Optional(Type.Union([
                Type.Literal("Product"),
                Type.Literal("Subscription"),
                Type.Literal("Voucher"),
            ], {})),
            google_business_vertical: Type.Optional(Type.String({
                default: "retail",
                readOnly: true,
            })),
            flexibleSalesChannels: Type.Optional(Type.Object({
                sourceId: Type.Union([
                    Type.String({}),
                    Type.Null({}),
                ]),
                sellerId: Type.Union([
                    Type.String({}),
                    Type.Null({}),
                ]),
                type: Type.Optional(Type.Union([
                    Type.Literal("asos"),
                    Type.Literal("dtc"),
                    Type.Literal("afs_prime"),
                    Type.Literal("afs_non_prime"),
                ], {})),
                isPrimary: Type.Optional(Type.Boolean({})),
                isSecondary: Type.Optional(Type.Boolean({})),
            }, {
                additionalProperties: false,
            })),
            badges: Type.Optional(Type.Array(Type.Union([
                Type.Literal("Selling Fast"),
                Type.Literal("More Colours"),
                Type.Literal("Mix & Match"),
                Type.Literal("Early Access"),
                Type.Literal("Sale"),
                Type.Literal("Low in Stock"),
                Type.Literal("Out of Stock"),
                Type.Literal("Restocking Soon"),
                Type.Literal("Hot Product"),
                Type.Literal("Discontinued"),
                Type.Literal("Popular"),
            ]), {})),
        }, {
            $schema: "http://json-schema.org/draft-07/schema#",
            additionalProperties: false,
        }), { description: "List of items in the order" }),
        returnedItems: Type.Array(Type.Object({
            variantId: Type.String({}),
            quantity: Type.Number({
                minimum: 0,
            }),
        }, { additionalProperties: false }), { description: "List of items that have been returned" }),
        currency: Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            default: "GBP",
            readOnly: true,
        }),
        localCurrencyCode: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
        })),
        value: Type.Number({
            $schema: "http://json-schema.org/draft-07/schema#",
        }),
        valueLocalCurrency: Type.Optional(Type.Number({
            $schema: "http://json-schema.org/draft-07/schema#",
        })),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/view_order_details.json",
        additionalProperties: false,
    })),
    view_order_list: Type.Optional(Type.Object({
        event: Type.Optional(Type.String({ default: "view_order_list", readOnly: true })),
        pageNumber: Type.Number({
            minimum: 0,
        }),
        pageSize: Type.Number({
            minimum: 0,
        }),
        totalOrders: Type.Number({
            minimum: 0,
        }),
        orders: Type.Array(Type.Object({
            orderId: Type.Number({}),
            orderReference: Type.String({}),
            orderStatus: Type.String({}),
            createdDate: Type.String({
                pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
                examples: ["2025-08-02T12:49:31.9122811Z"],
            }),
            store: Type.String({}),
            shop: Type.Union([Type.Literal("asos"), Type.Literal("topshop")], {
                $schema: "http://json-schema.org/draft-07/schema#",
            }),
            lang: Type.String({}),
            estimatedRemorseExpiryDate: Type.Union([
                Type.String({
                    pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
                }),
                Type.Null(),
            ], {}),
            cancellationDate: Type.Union([
                Type.String({
                    pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
                }),
                Type.Null(),
            ], {}),
            isReturnable: Type.Boolean({}),
            isWithinReturnWindow: Type.Boolean({}),
            returnWindowEndDate: Type.Union([
                Type.String({
                    pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
                }),
                Type.Null(),
            ], {}),
            isCancellable: Type.Boolean({}),
            orderDispatchedDate: Type.Union([
                Type.String({
                    pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
                }),
                Type.Null(),
            ], {}),
            orderDeliveredDate: Type.Union([
                Type.String({
                    pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
                }),
                Type.Null(),
            ], {}),
            parentOrderReference: Type.Union([
                Type.String({}),
                Type.Null({}),
            ]),
            rootOrderReference: Type.Union([
                Type.String({}),
                Type.Null({}),
            ]),
            notReturnableReasonCode: Type.Union([
                Type.String({}),
                Type.Null({}),
            ]),
            createReturnByDate: Type.Union([
                Type.String({
                    pattern: "^([\\+-]?\\d{4}(?!\\d{2}\\b))((-?)((0[1-9]|1[0-2])(\\3([12]\\d|0[1-9]|3[01]))?|W([0-4]\\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\\d|[12]\\d{2}|3([0-5]\\d|6[1-6])))([T\\s]((([01]\\d|2[0-3])((:?)[0-5]\\d)?|24\\:?00)([\\.,]\\d+(?!:))?)?(\\17[0-5]\\d([\\.,]\\d+)?)?([zZ]|([\\+-])([01]\\d|2[0-3]):?([0-5]\\d)?)?)?)?$",
                }),
                Type.Null(),
            ], {}),
            items: Type.Array(Type.Object({
                item_id: Type.Optional(Type.String({})),
                productId: Type.Optional(Type.String({})),
                productCode: Type.Optional(Type.String({})),
                variantId: Type.Optional(Type.String({})),
                item_name: Type.Optional(Type.String({})),
                discount: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                discountLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                index: Type.Optional(Type.Number({})),
                item_brand: Type.Optional(Type.String({})),
                item_category: Type.Optional(Type.String({})),
                item_variant: Type.Optional(Type.String({})),
                price: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                priceLocalCurrency: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                quantity: Type.Optional(Type.Number({
                    minimum: 0,
                })),
                coupon: Type.Optional(Type.String({})),
                size: Type.Optional(Type.String({})),
                image_url: Type.Optional(Type.String({})),
                itemType: Type.Optional(Type.Union([
                    Type.Literal("Product"),
                    Type.Literal("Subscription"),
                    Type.Literal("Voucher"),
                ], {})),
                google_business_vertical: Type.Optional(Type.String({
                    default: "retail",
                    readOnly: true,
                })),
                flexibleSalesChannels: Type.Optional(Type.Object({
                    sourceId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    sellerId: Type.Union([
                        Type.String({}),
                        Type.Null({}),
                    ]),
                    type: Type.Optional(Type.Union([
                        Type.Literal("asos"),
                        Type.Literal("dtc"),
                        Type.Literal("afs_prime"),
                        Type.Literal("afs_non_prime"),
                    ], {})),
                    isPrimary: Type.Optional(Type.Boolean({})),
                    isSecondary: Type.Optional(Type.Boolean({})),
                }, {
                    additionalProperties: false,
                })),
                badges: Type.Optional(Type.Array(Type.Union([
                    Type.Literal("Selling Fast"),
                    Type.Literal("More Colours"),
                    Type.Literal("Mix & Match"),
                    Type.Literal("Early Access"),
                    Type.Literal("Sale"),
                    Type.Literal("Low in Stock"),
                    Type.Literal("Out of Stock"),
                    Type.Literal("Restocking Soon"),
                    Type.Literal("Hot Product"),
                    Type.Literal("Discontinued"),
                    Type.Literal("Popular"),
                ]), {})),
            }, {
                $schema: "http://json-schema.org/draft-07/schema#",
                additionalProperties: false,
            }), {}),
            returnedItems: Type.Array(Type.Object({
                variantId: Type.String({}),
                quantity: Type.Number({
                    minimum: 0,
                }),
            }, { additionalProperties: false }), {}),
        }, {
            $schema: "http://json-schema.org/draft-07/schema#",
            additionalProperties: false,
        }), {}),
        ueid: Type.Optional(Type.String({
            $schema: "http://json-schema.org/draft-07/schema#",
            readOnly: true,
        })),
    }, {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "https://asos.com/dataLayer/events/view_order_list.json",
        additionalProperties: false,
    })),
}, {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://asos.com/dataLayer/events.json",
});

const dataLayerEventKeys = Object.values(types.properties).map((schema) => schema.properties.event.default);

function getWindow() {
    return globalThis.window;
}

const pushToDataLayerSitechromeWrapper = async (definitions) => {
    var _a, _b;
    const { pushToDataLayer } = (_b = (_a = getWindow().asos) === null || _a === void 0 ? void 0 : _a.siteChrome) !== null && _b !== void 0 ? _b : {};
    if (pushToDataLayer) {
        return await pushToDataLayer(definitions);
    }
    return new Promise((resolve, reject) => {
        var _a, _b, _c;
        const timeoutId = setTimeout(() => {
            reject(new Error("Timeout: pushToDataLayer-ready event was not fired within 10 seconds"));
        }, 10000);
        (_c = (_b = (_a = getWindow().asos) === null || _a === void 0 ? void 0 : _a.eventBus) === null || _b === void 0 ? void 0 : _b.once) === null || _c === void 0 ? void 0 : _c.call(_b, "pushToDataLayer-ready", async () => {
            var _a, _b, _c;
            clearTimeout(timeoutId);
            try {
                const result = await ((_c = (_b = (_a = getWindow().asos) === null || _a === void 0 ? void 0 : _a.siteChrome) === null || _b === void 0 ? void 0 : _b.pushToDataLayer) === null || _c === void 0 ? void 0 : _c.call(_b, definitions));
                resolve(result);
            }
            catch (e) {
                reject(e);
            }
        });
    });
};

const defaults = (eventDefinition, eventType) => Value.Default(Index(types, [eventType]), eventDefinition);

const clean = (eventDefinition, eventType) => Value.Clean(Index(types, [eventType]), eventDefinition);

const validate = (eventDefinition, eventType) => {
    const errors = [...Value.Errors(Index(types, [eventType]), eventDefinition)];
    if (errors.length) {
        throw new DataLayerError({
            message: `Object is not a valid match to the ${eventType} schema`,
            errors
        });
    }
};

const handleFailedEvent = async (args, eventDefinition, error) => {
    if (eventDefinition.event === "failed_event") {
        return undefined;
    }
    error.message = `${error.message}: See full error.validationErrors for details`;
    args.logError(error);
    return processEvent("failed_event", {
        failed_event: {
            event_context: eventDefinition,
            errors: (error === null || error === void 0 ? void 0 : error.validationErrors) || []
        }
    }, args);
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

const ueid = async (definition) => {
    definition.ueid = v4();
    return definition;
};

function getType(sourceId, sellerId) {
    if (!sellerId)
        return "asos";
    if (!sourceId)
        return "afs_prime";
    return sellerId === sourceId ? "dtc" : "afs_non_prime";
}
function transformSellerId(flexibleSalesChannelsType, sellerId) {
    if (flexibleSalesChannelsType === "asos")
        return flexibleSalesChannelsType;
    if (flexibleSalesChannelsType === "afs_prime" ||
        flexibleSalesChannelsType === "afs_non_prime")
        return `afs - ${sellerId}`;
    return sellerId || "";
}
const flexibleSalesChannels = async (definition) => {
    if ("ecommerce" in definition &&
        definition.ecommerce &&
        "items" in definition.ecommerce &&
        Array.isArray(definition.ecommerce.items)) {
        definition.ecommerce.items = definition.ecommerce.items.map(item => {
            if (item.flexibleSalesChannels) {
                const { sourceId, sellerId } = item.flexibleSalesChannels;
                const fulfillmentType = getType(sourceId, sellerId);
                return {
                    ...item,
                    flexibleSalesChannels: {
                        ...item.flexibleSalesChannels,
                        sellerId: transformSellerId(fulfillmentType, sellerId),
                        type: fulfillmentType,
                        isPrimary: !sourceId,
                        isSecondary: !!sourceId
                    }
                };
            }
            return item;
        });
    }
    return definition;
};

const viewportDimensions = async (definition, eventKey) => {
    const window = getWindow();
    if (eventKey === "pageData" && !definition.viewportDimensions) {
        if (typeof window !== "undefined") {
            const height = window.innerHeight || "";
            const width = window.innerWidth || "";
            definition.viewportDimensions =
                typeof width === "number" && typeof height === "number"
                    ? width + ":" + height
                    : null;
        }
        else {
            definition.viewportDimensions = null;
        }
    }
    return definition;
};

let e=-1;const t=t=>{addEventListener("pageshow",(n=>{n.persisted&&(e=n.timeStamp,t(n));}),!0);},n=(e,t,n,i)=>{let s,o;return r=>{t.value>=0&&(r||i)&&(o=t.value-(s??0),(o||void 0===s)&&(s=t.value,t.delta=o,t.rating=((e,t)=>e>t[1]?"poor":e>t[0]?"needs-improvement":"good")(t.value,n),e(t)));}},i=e=>{requestAnimationFrame((()=>requestAnimationFrame((()=>e()))));},s=()=>{const e=performance.getEntriesByType("navigation")[0];if(e&&e.responseStart>0&&e.responseStart<performance.now())return e},o=()=>{const e=s();return e?.activationStart??0},r=(t,n=-1)=>{const i=s();let r="navigate";e>=0?r="back-forward-cache":i&&(document.prerendering||o()>0?r="prerender":document.wasDiscarded?r="restore":i.type&&(r=i.type.replace(/_/g,"-")));return {name:t,value:n,rating:"good",delta:0,entries:[],id:`v5-${Date.now()}-${Math.floor(8999999999999*Math.random())+1e12}`,navigationType:r}};const h=(e,t,n={})=>{try{if(PerformanceObserver.supportedEntryTypes.includes(e)){const i=new PerformanceObserver((e=>{Promise.resolve().then((()=>{t(e.getEntries());}));}));return i.observe({type:e,buffered:!0,...n}),i}}catch{}};let u=-1;const l=new Set,m=()=>"hidden"!==document.visibilityState||document.prerendering?1/0:0,p=e=>{if("hidden"===document.visibilityState){if("visibilitychange"===e.type)for(const e of l)e();isFinite(u)||(u="visibilitychange"===e.type?e.timeStamp:0,removeEventListener("prerenderingchange",p,!0));}},v=()=>{if(u<0){const e=o(),n=document.prerendering?void 0:globalThis.performance.getEntriesByType("visibility-state").filter((t=>"hidden"===t.name&&t.startTime>e))[0]?.startTime;u=n??m(),addEventListener("visibilitychange",p,!0),addEventListener("prerenderingchange",p,!0),t((()=>{setTimeout((()=>{u=m();}));}));}return {get firstHiddenTime(){return u},onHidden(e){l.add(e);}}},g=e=>{document.prerendering?addEventListener("prerenderingchange",(()=>e()),!0):e();},y=[1800,3e3],E=(e,s={})=>{g((()=>{const c=v();let a,d=r("FCP");const f=h("paint",(e=>{for(const t of e)"first-contentful-paint"===t.name&&(f.disconnect(),t.startTime<c.firstHiddenTime&&(d.value=Math.max(t.startTime-o(),0),d.entries.push(t),a(!0)));}));f&&(a=n(e,d,y,s.reportAllChanges),t((t=>{d=r("FCP"),a=n(e,d,y,s.reportAllChanges),i((()=>{d.value=performance.now()-t.timeStamp,a(!0);}));})));}));};const H=[800,1800],O=e=>{document.prerendering?g((()=>O(e))):"complete"!==document.readyState?addEventListener("load",(()=>O(e)),!0):setTimeout(e);},$=(e,i={})=>{let c=r("TTFB"),a=n(e,c,H,i.reportAllChanges);O((()=>{const d=s();d&&(c.value=Math.max(d.responseStart-o(),0),c.entries=[d],a(!0),t((()=>{c=r("TTFB",0),a=n(e,c,H,i.reportAllChanges),a(!0);})));}));};

const TTFB_TIMEOUT_MS = 1000;
const measureTTFB = async () => new Promise(resolve => {
    $(metric => {
        resolve(Math.round(metric.value));
    });
    setTimeout(() => resolve(null), TTFB_TIMEOUT_MS);
});
const getTTFBForDataLayer = async () => {
    try {
        const ttfbValue = await measureTTFB();
        if (ttfbValue !== null) {
            return {
                timeToFirstByteData: {
                    value: ttfbValue
                }
            };
        }
    }
    catch (_a) {
        return undefined;
    }
};
const timeToFirstByteEvent = async (definition, eventKey) => {
    if (eventKey !== "pageData" || typeof getWindow() === "undefined") {
        return { definition, additionalEvents: undefined };
    }
    return {
        definition,
        additionalEvents: await getTTFBForDataLayer()
    };
};

class MiddlewareManager {
    constructor() {
        this.globalMiddlewares = [];
        this.eventMiddlewares = {};
        this.additionalEventsQueue = [];
    }
    use(middleware) {
        this.globalMiddlewares.push(middleware);
    }
    useForEvent(eventKey, middleware) {
        if (!this.eventMiddlewares[eventKey]) {
            this.eventMiddlewares[eventKey] = [];
        }
        this.eventMiddlewares[eventKey].push(middleware);
    }
    async run(definition, eventKey, args) {
        let result = definition;
        for (const mw of this.globalMiddlewares) {
            const globalMiddlewareResult = await mw(result);
            result = globalMiddlewareResult;
        }
        if (this.eventMiddlewares[eventKey]) {
            result = await this.processEventMiddlewares(result, eventKey, args);
        }
        return result;
    }
    async processEventMiddlewares(result, eventKey, args) {
        for (const mw of this.eventMiddlewares[eventKey]) {
            const middlewareResult = await mw(result, eventKey, args);
            if (this.isMiddlewareResult(middlewareResult)) {
                result = middlewareResult.definition;
                if (middlewareResult.additionalEvents) {
                    this.additionalEventsQueue.push(middlewareResult.additionalEvents);
                }
            }
            else {
                result = middlewareResult;
            }
        }
        return result;
    }
    isMiddlewareResult(result) {
        return (typeof result === "object" && result !== null && "definition" in result);
    }
    getAndClearAdditionalEvents() {
        const events = [...this.additionalEventsQueue];
        this.additionalEventsQueue = [];
        return events;
    }
}

const FCP_TIMEOUT_MS = 1000;
const measureFCP = async () => new Promise(resolve => {
    E(metric => {
        resolve(Math.round(metric.value));
    });
    setTimeout(() => resolve(null), FCP_TIMEOUT_MS);
});
const getFCPForDataLayer = async () => {
    try {
        const fcpValue = await measureFCP();
        if (fcpValue !== null) {
            return {
                firstContentfulPaintData: {
                    value: fcpValue
                }
            };
        }
    }
    catch (_a) {
        return undefined;
    }
};
const firstContentfulPaintEvent = async (definition, eventKey) => {
    if (eventKey !== "pageData" || typeof getWindow() === "undefined") {
        return { definition, additionalEvents: undefined };
    }
    return {
        definition,
        additionalEvents: await getFCPForDataLayer()
    };
};

/**
 * Checks for Analytics.Config and returns the configuration
 * Ported from asos-web-analytics/src/platforms/cptbasic.sitechrome.js lines 10-22
 * Modified to return the config instead of dispatching events
 *
 * The analyticsConfig is provided by AnalyticsViewModel via content pages/sitecore
 * The underlying model code has been preserved as a temporary measure to not lose analytics functionality
 * It contains an elementsList string which is a comma-separated list of component names
 *
 * Example:
 * {
 *   elementsList: "hero,product container,footer",
 *   someOtherProperty: "value"
 * }
 *
 */
function checkForAnalyticsConfig() {
    const window = getWindow();
    if (!window) {
        return Promise.resolve(null);
    }
    return new Promise(resolve => {
        var _a;
        if ((_a = window.require) === null || _a === void 0 ? void 0 : _a.specified("Analytics.Config")) {
            window.require(["Analytics.Config"], function (analyticsConfig) {
                resolve(analyticsConfig);
            });
        }
        else {
            resolve(null);
        }
    });
}

function parseElementsList(elementsList) {
    return elementsList
        .split(",")
        .map(componentName => componentName.trim())
        .filter(componentName => componentName)
        .map((componentName, index) => ({
        position: index + 1,
        component_name: componentName
    }));
}
function hasElementsList(config) {
    return (config !== null &&
        typeof config === "object" &&
        "elementsList" in config &&
        typeof config.elementsList === "string");
}
async function getComponentsFromAnalytics() {
    const analyticsConfig = await checkForAnalyticsConfig();
    if (!hasElementsList(analyticsConfig)) {
        return null;
    }
    const { elementsList } = analyticsConfig;
    if (!elementsList) {
        return null;
    }
    return parseElementsList(elementsList);
}
const available_components = async (definition, eventKey) => {
    if (eventKey !== "pageData" || typeof getWindow() === "undefined") {
        return { definition, additionalEvents: undefined };
    }
    const components = await getComponentsFromAnalytics();
    if (!components) {
        return { definition, additionalEvents: undefined };
    }
    return {
        definition,
        additionalEvents: {
            available_components: {
                components
            }
        }
    };
};

/**
 * Hashes a string with crypto
 * @param stringToHash - string to be hashed
 * @returns hashed string
 */
const hashString = async (stringToHash) => {
    var _a, _b;
    if (!stringToHash) {
        return undefined;
    }
    const isEncryptionPossible = !!((_b = (_a = window.crypto) === null || _a === void 0 ? void 0 : _a.subtle) === null || _b === void 0 ? void 0 : _b.digest);
    if (!isEncryptionPossible) {
        return undefined;
    }
    else {
        const sanitisedValue = stringToHash.replace(/ /g, "").toLocaleLowerCase();
        const data = new TextEncoder().encode(sanitisedValue);
        const hashedBuffer = await window.crypto.subtle.digest("SHA-256", data);
        const hashArray = Array.from(new Uint8Array(hashedBuffer));
        const hashedString = hashArray
            .map(bytes => bytes.toString(16).padStart(2, "0"))
            .join("");
        return hashedString;
    }
};

// Mapped from https://github.com/asosteam/asos-web-auth-client/blob/main/src/auth-client/types/lastAction.ts
const LAST_ACTION_STRINGS = [
    "none",
    "signUpSocial",
    "signUpEmail",
    "linkAccounts",
    "savedBillingAddress",
    "savedBillingAndDeliveryAddress",
    "signInSocial",
    "signInEmail"
];
const lastActionToString = (value) => { var _a; return (_a = LAST_ACTION_STRINGS[value]) !== null && _a !== void 0 ? _a : "none"; };
const buildCustomerIdentityData = async (isAuthenticated, getIdTokenClaimsAsync) => {
    const { customerId, isFirstTimeBuyer, firstName, lastName, homeCountry, lastAction, customerSubscriptionCountry, loyaltyTier } = await getIdTokenClaimsAsync();
    return {
        customerIdentityData: {
            isAuthenticated: await isAuthenticated(),
            customerId: customerId,
            lastAction: lastActionToString(lastAction),
            firstTimeBuyer: isFirstTimeBuyer,
            hashedFirstName: await hashString(firstName),
            hashedLastName: await hashString(lastName),
            geoIpCountryCode: homeCountry || undefined,
            customerSubscriptionCountry: customerSubscriptionCountry || undefined,
            loyaltyTier: loyaltyTier || undefined
        }
    };
};
const dependenciesArePresent = (getIdTokenClaimsAsync, isAuthenticated) => {
    return getIdTokenClaimsAsync && isAuthenticated;
};
const customerIdentityData = async (definition, eventKey, { isAuthenticated, getIdTokenClaimsAsync, logError }) => {
    if (eventKey !== "pageData" ||
        typeof getWindow() === "undefined" ||
        !dependenciesArePresent(getIdTokenClaimsAsync, isAuthenticated)) {
        return { definition, additionalEvents: undefined };
    }
    try {
        const additionalEvents = await buildCustomerIdentityData(isAuthenticated, getIdTokenClaimsAsync);
        return {
            definition,
            additionalEvents
        };
    }
    catch (error) {
        logError(new DataLayerError({
            message: `Failed to get identity claims in customerIdentityData: ${error}`
        }));
        return { definition, additionalEvents: undefined };
    }
};

const parseLoyaltyTier = (loyaltyTier) => {
    const match = loyaltyTier.match(/^([A-Za-z]+)_LOYT_(\d+)$/);
    return {
        country: (match === null || match === void 0 ? void 0 : match[1]) || null,
        tierNumber: (match === null || match === void 0 ? void 0 : match[2]) ? parseInt(match[2], 10) : null
    };
};
const getCustomerLoyaltyData = (loyaltyTier) => {
    if (!loyaltyTier) {
        return {
            consentStatus: null,
            currentTierId: null,
            tierNumber: null,
            country: null
        };
    }
    const { country, tierNumber } = parseLoyaltyTier(loyaltyTier);
    return {
        consentStatus: "OptedIn",
        currentTierId: loyaltyTier,
        tierNumber,
        country
    };
};
const customerLoyaltyData = async (definition, eventKey) => {
    if (eventKey !== "customerIdentityData" ||
        typeof getWindow() === "undefined") {
        return { definition, additionalEvents: undefined };
    }
    return {
        definition,
        additionalEvents: {
            customerLoyaltyData: getCustomerLoyaltyData(definition.loyaltyTier)
        }
    };
};

// Helper for handling auth client events
class AuthEventHelper {
    constructor() {
        this.loginEventFired = false;
        this.loginPromise = new Promise((resolve, reject) => {
            if (typeof window !== "undefined") {
                window.addEventListener("AsosAuthClient.onLoggedIn", () => {
                    this.loginEventFired = true;
                    resolve();
                });
            }
            else {
                reject();
            }
        });
    }
    async waitForLogin(timeoutMs = 200) {
        if (this.loginEventFired)
            return true;
        try {
            await Promise.race([
                this.loginPromise,
                new Promise((_, reject) => {
                    setTimeout(reject, timeoutMs);
                })
            ]);
            return true;
        }
        catch (_a) {
            return false;
        }
    }
}
// Export a singleton instance
const authEventHelper = new AuthEventHelper();

const getAuthenticationChannel$1 = (lastAction) => {
    switch (lastAction) {
        case "signInSocial":
            return "social";
        case "signInEmail":
            return "email";
        default:
            return "unknown";
    }
};
const successful_login = async (definition, eventKey) => {
    if (eventKey !== "customerIdentityData" ||
        typeof getWindow() === "undefined") {
        return { definition, additionalEvents: undefined };
    }
    const loginOccurred = await authEventHelper.waitForLogin();
    if (!loginOccurred) {
        return { definition, additionalEvents: undefined };
    }
    const authenticationChannel = getAuthenticationChannel$1(definition.lastAction);
    if (authenticationChannel === "unknown") {
        return { definition, additionalEvents: undefined };
    }
    return {
        definition,
        additionalEvents: {
            successful_login: {
                authentication_channel: authenticationChannel
            }
        }
    };
};

const getAuthenticationChannel = (lastAction) => {
    switch (lastAction) {
        case "signUpSocial":
            return "social";
        case "signUpEmail":
            return "email";
        default:
            return "unknown";
    }
};
const successful_registration = async (definition, eventKey) => {
    if (eventKey !== "customerIdentityData" ||
        typeof getWindow() === "undefined") {
        return { definition, additionalEvents: undefined };
    }
    const registrationOccurred = await authEventHelper.waitForLogin();
    if (!registrationOccurred) {
        return { definition, additionalEvents: undefined };
    }
    const authenticationChannel = getAuthenticationChannel(definition.lastAction);
    if (authenticationChannel === "unknown") {
        return { definition, additionalEvents: undefined };
    }
    return {
        definition,
        additionalEvents: {
            successful_registration: {
                authentication_channel: authenticationChannel
            }
        }
    };
};

const getHashParameters = () => {
    const window = getWindow();
    let hashString = new URL(window.location.href).hash;
    const parametersObject = new Map();
    if (!hashString) {
        return parametersObject;
    }
    if (hashString.charAt(0) === "#") {
        hashString = hashString.substring(1);
    }
    const parameters = hashString.split(/[&#]/);
    parameters.forEach((parameter) => {
        let parts = parameter.split(/=(.*)/s);
        if (parts.length == 1) {
            parts = parameter.split(/-(.*)/s);
        }
        const firstPart = parts[0];
        if (firstPart) {
            parametersObject.set(firstPart, decodeURIComponent((parts[1] || "").replace(/\+/g, " ")));
        }
    });
    return parametersObject;
};

const findCaseInsensitive = (parameterKey, hashParameters, queryParameters) => {
    const lowerParamKey = parameterKey.toLowerCase();
    // Check hash parameters
    for (const [key, value] of hashParameters.entries()) {
        if (key.toLowerCase() === lowerParamKey) {
            return value;
        }
    }
    // Check query parameters
    for (const [key, value] of queryParameters.entries()) {
        if (key.toLowerCase() === lowerParamKey) {
            return value;
        }
    }
    return null;
};
const getUrlParameter = (parameterKey, caseInsensitive = false) => {
    const window = getWindow();
    const url = new URL(window.location.href);
    const hashParameters = getHashParameters();
    if (caseInsensitive) {
        return findCaseInsensitive(parameterKey, hashParameters, url.searchParams);
    }
    if (hashParameters.has(parameterKey)) {
        return hashParameters.get(parameterKey);
    }
    if (url.searchParams.has(parameterKey)) {
        return url.searchParams.get(parameterKey);
    }
    return null;
};

const CTA_REF_KEY = "ctaRef";
const ctaRef = (definition, eventKey) => {
    if (eventKey === "pageData" && !definition.ctaRef) {
        if (typeof window !== "undefined") {
            const ctaRef = getUrlParameter(CTA_REF_KEY, true);
            if (ctaRef) {
                definition.ctaRef = ctaRef;
            }
        }
    }
    return definition;
};

const middlewareManager = new MiddlewareManager();
// Global Middleware
middlewareManager.use(ueid);
middlewareManager.use(flexibleSalesChannels);
// Field Middleware
middlewareManager.useForEvent("pageData", viewportDimensions);
// Additional Event Middleware
middlewareManager.useForEvent("pageData", timeToFirstByteEvent);
middlewareManager.useForEvent("pageData", firstContentfulPaintEvent);
middlewareManager.useForEvent("pageData", available_components);
middlewareManager.useForEvent("pageData", customerIdentityData);
middlewareManager.useForEvent("pageData", ctaRef);
middlewareManager.useForEvent("customerIdentityData", customerLoyaltyData);
middlewareManager.useForEvent("customerIdentityData", successful_login);
middlewareManager.useForEvent("customerIdentityData", successful_registration);

const processEvent = async (eventKey, definitions, args) => {
    let eventDefinition = defaults(definitions[eventKey], eventKey);
    eventDefinition = clean(eventDefinition, eventKey);
    eventDefinition = await middlewareManager.run(eventDefinition, eventKey, args);
    try {
        validate(eventDefinition, eventKey);
        return eventDefinition;
    }
    catch (error) {
        return await handleFailedEvent(args, eventDefinition, error);
    }
};

const pushToDataLayer = async (args, definitions) => {
    const { dataLayerSink, logError } = args;
    if (!dataLayerSink) {
        logError(new DataLayerError({ message: "Datalayer sink is not setup" }));
        return null;
    }
    const processedDefinitions = [];
    let eventKey;
    for (eventKey in definitions) {
        const eventDefinition = await processEvent(eventKey, definitions, args);
        if (eventDefinition !== undefined) {
            await dataLayerSink({
                events: [eventDefinition.event],
                data: eventDefinition
            });
            processedDefinitions.push(eventDefinition);
        }
    }
    const middlewareProcessedDefinitions = await processAdditionalEvents(args);
    return [...processedDefinitions, ...middlewareProcessedDefinitions];
};
const processAdditionalEvents = async (args) => {
    const processedDefinitions = [];
    const middlewareEventBatches = middlewareManager.getAndClearAdditionalEvents();
    const middlewarePromises = middlewareEventBatches.map(middlewareEventBatch => pushToDataLayer(args, middlewareEventBatch));
    const middlewareResults = await Promise.all(middlewarePromises);
    for (const middlewareProcessedDefinitions of middlewareResults) {
        if (middlewareProcessedDefinitions) {
            processedDefinitions.push(...middlewareProcessedDefinitions);
        }
    }
    return processedDefinitions;
};

export { DataLayerError, dataLayerEventKeys, pushToDataLayer, pushToDataLayerSitechromeWrapper };
//# sourceMappingURL=index.js.map
